// WebAuthn exchanges binary fields as unpadded base64url strings; these
// convert the JSON ceremony options and results to and from ArrayBuffers.
const WebAuthnCodec = {
  toBuffer(value) {
    const base64 = value.replace(/-/g, "+").replace(/_/g, "/");
    const binary = atob(base64 + "=".repeat((4 - (base64.length % 4)) % 4));
    return Uint8Array.from(binary, (character) => character.charCodeAt(0));
  },

  fromBuffer(buffer) {
    return btoa(String.fromCharCode(...new Uint8Array(buffer)))
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  },

  decodeRequestOptions(options) {
    return {
      ...options,
      challenge: this.toBuffer(options.challenge),
      allowCredentials: (options.allowCredentials || []).map((credential) => ({
        ...credential,
        id: this.toBuffer(credential.id),
      })),
    };
  },

  encodeAssertion(assertion) {
    return {
      id: assertion.id,
      rawId: this.fromBuffer(assertion.rawId),
      type: assertion.type,
      response: {
        authenticatorData: this.fromBuffer(
          assertion.response.authenticatorData
        ),
        clientDataJSON: this.fromBuffer(assertion.response.clientDataJSON),
        signature: this.fromBuffer(assertion.response.signature),
        userHandle: assertion.response.userHandle
          ? this.fromBuffer(assertion.response.userHandle)
          : null,
      },
    };
  },

  decodeCreationOptions(options) {
    const publicKey = options.publicKey || options;
    return {
      challenge: this.toBuffer(publicKey.challenge),
      rp: publicKey.rp,
      user: {
        ...publicKey.user,
        id: this.toBuffer(publicKey.user.id),
      },
      pubKeyCredParams: publicKey.pubKeyCredParams,
      timeout: publicKey.timeout,
      excludeCredentials: (publicKey.excludeCredentials || []).map(
        (credential) => ({
          ...credential,
          id: this.toBuffer(credential.id),
        })
      ),
      authenticatorSelection: publicKey.authenticatorSelection,
      attestation: publicKey.attestation,
    };
  },

  encodeAttestation(attestation) {
    return {
      id: attestation.id,
      rawId: this.fromBuffer(attestation.rawId),
      type: attestation.type,
      response: {
        attestationObject: this.fromBuffer(
          attestation.response.attestationObject
        ),
        clientDataJSON: this.fromBuffer(attestation.response.clientDataJSON),
      },
    };
  },
};

export default WebAuthnCodec;
